import React, { useCallback, useMemo, useRef } from "react";
import * as s from "./styles/cards.module.css";
import * as cs from "./styles/card.module.css";
import * as ds from "./styles/dots.module.css";
import links from "../../data/links.json";

import VKMusic from "./svg/vk-music.inline.svg";
import VKCalls from "./svg/vk-calls.inline.svg";
import VKClips from "./svg/vk-clips.inline.svg";
// import VKPlay from "./svg/vk-play.inline.svg";
import VKFest from "./svg/vk-fest.inline.svg";
import VKVideo from "./svg/vk-video.inline.svg";
import VKStore from "./svg/vk-store.inline.svg";
import VKStadium from "./svg/vk-stadium.inline.svg";
import { Marusya } from "./Marusya";

import { T } from "../../components";
import classNames from "classnames";
import { useState } from "react";
import { useEffect } from "react";
import { useMobile } from "./utils";
import { useActiveDesktop } from "./use-active-desktop";
import { useActiveMobile } from "./use-active-mobile";

const Card = ({ text, title, linkText, href, active, index, setSection }) => {
	const SVG = title;
	const el = useRef();

	return (
		// rome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
		<div
			className={classNames(cs.card, active && cs.active)}
			ref={el}
			data-index={index}
			onClick={() => setSection(index)}
		>
			<SVG className={cs.logo} />

			<p className={cs.text}>
				<T id={text} />
			</p>

			<a
				target="_blank"
				rel="noopener noreferrer"
				className={cs.cardLink}
				href={href}
			>
				<T id={linkText} />
			</a>
		</div>
	);
};

const CARDS = [
	{
		title: VKMusic,
		text: "cards.music.text",
		linkText: "cards.music.action",
		href: links.music,
	},

	{
		title: VKClips,
		text: "cards.clips.text",
		linkText: "cards.clips.action",
		href: links.clips,
	},

	{
		title: VKCalls,
		text: "cards.calls.text",
		linkText: "cards.calls.action",
		href: links.calls,
	},

	{
		title: VKVideo,
		text: "cards.video.text",
		linkText: "cards.video.action",
		href: links.video,
	},

	{
		title: VKFest,
		text: "cards.fest.text",
		linkText: "cards.fest.action",
		href: links.fest,
	},

	{
		title: Marusya,
		text: "cards.marusya.text",
		linkText: "cards.marusya.action",
		href: links.marusya,
	},

	{
		title: VKStadium,
		text: "cards.stadium.text",
		linkText: "cards.stadium.action",
		href: links.stadium,
	},

	{
		title: VKStore,
		text: "cards.store.text",
		linkText: "cards.store.action",
		href: links.store,
	},
];

export const Cards = () => {
	const mobile = useMobile();
	const blockRef = useRef();

	const { active: activeDesktop, setSection } = useActiveDesktop(blockRef, !mobile);
	let activeMobile = useActiveMobile(blockRef, mobile);

	const active = mobile ? activeMobile : activeDesktop;

	return (
		<>
			<div className={s.block} ref={blockRef}>
				{CARDS.map(({ title, text, linkText, href }, i) => (
					<Card
						key={title}
						index={i}
						title={title}
						text={text}
						linkText={linkText}
						href={href}
						setSection={setSection}
					/>
				))}
			</div>
			<div className={ds.dots}>
				{CARDS.map((_, i) => (
					<div
						// rome-ignore lint/suspicious/noArrayIndexKey: <explanation>
						key={i}
						className={classNames(ds.dot, i === active && ds.active)}
					/>
				))}
			</div>
		</>
	);
};
